<div class="row no-gutters">
    <div class="col">
      <bc-calendar *ngIf="!(calendarEvents$ | async).isLoading && (calendarSettings$ | async).loaded && (calendarResources$ | async).loaded && (calendarResources$ | async).hasItems"
        [settings]="(calendarSettings$ | async).data" [events]="(calendarEvents$ | async).items"
        [resources]="(calendarResources$ | async).items" (eventClicked)="onEventClicked($event)"
        (addClicked)="onAddClicked($event)" (cancelledClicked)="onCancelledClicked($event)"></bc-calendar>
    </div>
  </div>
